var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-icon',{class:_vm.icons[_vm.portfolioType].color,attrs:{"pack":"fas","icon":_vm.icons[_vm.portfolioType].icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }